import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { track } from '../lib/analytics';
import './Navigation.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/specialties', label: 'Specialties' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/book', label: 'Book Now' },
  { to: '/shop', label: 'Shop' },
];

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, isAdmin, user, logout } = useAuth();
  const { settings } = useSiteSettings();
  const shopVisible = settings?.shopVisible !== false;
  const visibleLinks = NAV_LINKS.filter((l) => shopVisible || l.to !== '/shop');
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const handleLogout = async () => { await logout(); navigate('/'); };
  const handleNavClick = (to) => {
    if (to === '/book') track('BOOK_INTENT', location.pathname);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/" className="brand-link">
            <span className="brand-name">Prancing Peony Spa</span>
            <span className="brand-tagline">Massage &amp; Bodywork</span>
          </Link>
        </div>

        <ul className="nav-menu">
          {visibleLinks.map((l) => (
            <li key={l.to} className="nav-item">
              <Link to={l.to} className="nav-link" onClick={() => handleNavClick(l.to)}>{l.label}</Link>
            </li>
          ))}
          {isAdmin && (
            <li className="nav-item">
              <Link to="/admin" className="nav-link admin-link">Admin</Link>
            </li>
          )}
        </ul>

        <div className="nav-icons">
          {isAuthenticated && (
            <div className="user-menu">
              <span className="user-email">{user?.email}</span>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>

        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span><span></span><span></span>
        </button>
      </div>

      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <ul className="mobile-menu-list">
          {visibleLinks.map((l) => (
            <li key={l.to}><Link to={l.to} onClick={() => { handleNavClick(l.to); toggleMenu(); }}>{l.label}</Link></li>
          ))}
          {isAdmin && <li><Link to="/admin" onClick={toggleMenu}>Admin Dashboard</Link></li>}
          {isAuthenticated && (
            <li>
              <button onClick={() => { handleLogout(); toggleMenu(); }} className="mobile-logout">Logout</button>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
}
